{
  "a11y": {
    "home": "Miami To-Do — главная",
    "menu": "Меню",
    "closeMenu": "Закрыть меню",
    "search": "Поиск",
    "language": "Язык: {{name}}",
    "mainNav": "Главное меню",
    "categories": "Категории",
    "open": "Открыть: {{title}}",
    "breadcrumb": "Навигационная цепочка",
    "saved": "Избранное",
    "account": "Аккаунт",
    "save": "Сохранить: {{title}}"
  },
  "nav": {
    "tours": "Экскурсии",
    "boats": "Яхты и лодки",
    "everglades": "Эверглейдс",
    "attractions": "Достопримечательности",
    "dayTrips": "Поездки на день",
    "home": "Главная"
  },
  "home": {
    "metaTitle": "Чем заняться в Майами — экскурсии, катера и Эверглейдс",
    "metaDescription": "Чем заняться в Майами: прогулки на катере по заливу Бискейн, аэроглиссеры в Эверглейдс, квартал ар-деко в Саут-Бич, стрит-арт Винвуда и поездки в Ки-Уэст.",
    "heroEyebrow": "Ваш путеводитель по Майами",
    "heroTitle": "Каждый день — особенный.",
    "heroLead": "Лучшие экскурсии, морские прогулки и впечатления Майами — в одном месте.",
    "heroAlt": "Небоскрёбы центра Майами над заливом Бискейн, яхта и пальмы",
    "featuredTitle": "Выбор недели",
    "featuredEyebrow": "Лучшее в Майами прямо сейчас",
    "viewAllExperiences": "Все впечатления",
    "moodTitle": "Под настроение",
    "moodEyebrow": "Идеи для любого случая",
    "viewAllCategories": "Все категории",
    "guideTitle": "Чем заняться в Майами: по категориям",
    "guideCount_one": "{{count}} вариант",
    "guideCount_few": "{{count}} варианта",
    "guideCount_many": "{{count}} вариантов",
    "guideCount_other": "{{count}} варианта",
    "guide": {
      "boats": {
        "text": "Залив Бискейн с воды: обзорные круизы вдоль небоскрёбов и вилл знаменитостей на Миллионерском ряду и Стар-Айленде, закатные круизы с шампанским и лодки-вечеринки с напитками. Частные лодки и яхты с капитаном, обычно до 12–13 гостей, идут к отмели Haulover или Raccoon Island купаться; в некоторые входят гидроциклы или банан.",
        "link": "Все морские прогулки"
      },
      "everglades": {
        "text": "Болота Эверглейдс начинаются меньше чем в часе езды к западу от города. Чаще всего это прогулка на аэролодке по травяным равнинам — с аллигаторами и болотными птицами: час на индивидуальной или полуиндивидуальной лодке или полдня с трансфером от отеля, шоу с животными или прогулкой по национальному парку Эверглейдс. Есть и комбо-туры: аэролодка, круиз по заливу Бискейн и обзорная экскурсия.",
        "link": "Все туры в Эверглейдс"
      },
      "city-tours": {
        "text": "Районы Майами на гольф-каре, багги, сегвее, велосипеде, открытом автобусе или пешком: граффити Винвуда, отели ар-деко и неон Саут-Бич, кафе Маленькой Гаваны. Туры «три в одном» показывают все три района за полдня, другие посвящены стрит-арту, еде, местам киносъёмок или Корал-Гейблс.",
        "link": "Все обзорные экскурсии"
      },
      "day-trips": {
        "text": "Поездки на целый день из Майами с транспортом: по Заморскому шоссе через Ки-Ларго и Исламораду до Ки-Уэста, на север — в Космический центр Кеннеди, или в Форт-Лодердейл и Палм-Бич с музеем Флаглера. Ездят и небольшими группами на минивэне, и с личным водителем.",
        "link": "Все поездки на день"
      },
      "water-sports": {
        "text": "Главная площадка — залив Бискейн: гидроциклы с инструктором вдоль небоскрёбов и острова Стар-Айленд, яхты с гидроциклами, банан и тюбинг, вейксёрф, уроки водных лыж и водные автомобили. Многие выходят из марин Майами-Бич; перед бронированием проверьте, что входит в стоимость, — сборы бывают разными.",
        "link": "Все водные развлечения"
      },
      "attractions": {
        "text": "Билеты в музеи и достопримечательности Майами: иммерсивное искусство Superblue, Wynwood Walls, Художественный музей Переса (PAMM), музей и сады Вискайя, научный музей Фроста, зоопарк Майами и Jungle Island. Городские пассы объединяют несколько мест в одном билете.",
        "link": "Все достопримечательности"
      },
      "family": {
        "text": "Места, где интересно и детям, и взрослым: зоопарк Майами, встречи с животными в Jungle Island, научный музей Фроста с аквариумом и планетарием и Museum of Ice Cream. Explorer Pass открывает несколько мест по одному билету.",
        "link": "Всё для отдыха с детьми"
      }
    }
  },
  "search": {
    "label": "Куда в Майами?",
    "placeholder": "Куда в Майами?",
    "submit": "Найти",
    "landmark": "Поиск по Miami To-Do",
    "searchFor": "Искать «{{query}}»",
    "categories": "Категории",
    "popularTitle": "Часто ищут",
    "suggestions": "Подсказки",
    "popular": [
      { "label": "Аэроглиссер", "q": "airboat" },
      { "label": "Ки-Уэст", "q": "key west" },
      { "label": "Залив Бискейн", "q": "biscayne" },
      { "label": "Саут-Бич", "q": "south beach" },
      { "label": "Ар-деко", "q": "art deco" },
      { "label": "Винвуд", "q": "wynwood" },
      { "label": "Маленькая Гавана", "q": "little havana" },
      { "label": "Гидроцикл", "q": "jet ski" }
    ]
  },
  "mood": {
    "family": "С детьми"
  },
  "collections": {
    "tours": {
      "seoTitle": "Экскурсии в Майами: яхты, Эверглейдс, Ки-Уэст",
      "heading": "Экскурсии и туры в Майами",
      "intro": "Все экскурсии и впечатления Майами, которые мы рекомендуем, — сначала с лучшими отзывами.",
      "meta": "Все экскурсии в Майами по отзывам: морские прогулки по заливу Бискейн и частные яхты, аэроглиссеры в Эверглейдс, ар-деко, Винвуд и поездки на Ки-Уэст.",
      "guideTitle": "Как выбрать экскурсию в Майами",
      "guide": [
        {
          "h": "Какие бывают экскурсии",
          "p": [
            "Большая часть экскурсий в Майами — на воде. Обзорные круизы отходят от Bayside Marketplace в центре города примерно на час по заливу Бискейн — мимо особняков Стар-Айленда и Миллионерского ряда, круизного порта и небоскрёбов. Частная лодка с капитаном увозит вашу компанию на два-четыре часа: искупаться на песчаной отмели, встать на якорь у тихого острова или встретить закат напротив Брикелла. Остальное в заливе — гидроциклы, пати-лодки и рыбалка.",
            "Эверглейдс начинается меньше чем в часе езды к западу от города: аэроглиссеры несутся по болотной траве в поисках аллигаторов и цапель — от часовой прогулки до поездки на полдня с трансфером и остановкой в национальном парке. В самом городе пешие экскурсии и туры на гольф-карах и сегвеях проходят по кварталу ар-деко в Саут-Бич, муралам Винвуда, кафе и сигарным мастерским улицы Калье-Очо в Маленькой Гаване, а вертолёт или небольшой самолёт покажет Майами-Бич сверху. Поездки на целый день идут по Заморскому шоссе до Ки-Уэста или на север — в Форт-Лодердейл, Палм-Бич и Космический центр Кеннеди."
          ]
        },
        {
          "h": "Как спланировать дни в Майами",
          "p": [
            "Планируйте по жаре и погоде. Утром на воде спокойнее всего, а для аэроглиссеров и пеших прогулок прохладнее; летом после обеда часто собираются грозы, поэтому лодку и Эверглейдс бронируйте на утро, а вторую половину дня оставьте для музея или круиза на закате, когда дождь пройдёт. Вечер — время огней города: закатные круизы, неон Оушен-драйв и ужин в Брикелле или Винвуде.",
            "Трёх дней хватит на главное: день в Майами-Бич с кварталом ар-деко и прогулкой по заливу, день на Винвуд и Маленькую Гавану и утро в Эверглейдс. Добавьте длинный день на Ки-Уэст — около четырёх часов дороги в каждую сторону — или день на пляже. Сухой сезон, с ноября по апрель, — самый комфортный и самый загруженный: пик цен и толп приходится на Рождество, ярмарку Art Basel в начале декабря и весенние каникулы в марте; сезон ураганов длится с июня по ноябрь."
          ]
        },
        {
          "h": "Сборная, в мини-группе или частная?",
          "p": [
            "Сборные круизы и автобусные экскурсии — самый недорогой вариант, от 25–30 долларов с человека. В мини-группах людей меньше — гольф-кар по Винвуду, полуприватный аэроглиссер, микроавтобус на Ки-Уэст с дюжиной путешественников, — гид ближе, а цена умеренная. Частные экскурсии, а их в списке много, стоят дороже, зато только для вашей компании: лодка с капитаном на компанию до двенадцати человек, аэроглиссер или машина с гидом.",
            "У частной лодки цена обычно за всю компанию, а не за человека, так что вместе выходит выгоднее; проверьте, сколько гостей она берёт, входят ли топливо, напитки и водные развлечения и от какой марины она отходит — Майами-Бич, Bayside, Haulover или дальше по побережью. Экскурсии в Эверглейдс либо встречают вас в парке аэроглиссеров, либо включают трансфер из Майами — это указано в описании. В США принято оставлять чаевые капитану или гиду, обычно 15–20 % на частных турах, и часто они не входят в цену."
          ]
        },
        {
          "h": "Как устроен этот список",
          "p": [
            "На этой странице — все экскурсии и впечатления, которые есть у нас в Майами, по отзывам: тур с сотнями хороших отзывов стоит выше тура с идеальной оценкой всего от нескольких гостей. Откройте категорию, чтобы увидеть список короче.",
            "Бронирование — на сайте нашего партнёра Viator: там до оплаты видны актуальная цена в долларах, свободные даты и условия отмены. Многие экскурсии можно бесплатно отменить за 24 часа до начала, а большинство морских прогулок и аэроглиссеров при отмене из-за погоды предлагают другую дату или возврат денег."
          ]
        }
      ],
      "faq": [
        {
          "q": "Какие экскурсии в Майами лучшие?",
          "a": "Выше всего путешественники оценивают частную прогулку на лодке по заливу Бискейн с остановкой на песчаной отмели, аэроглиссер в Эверглейдс, пешую экскурсию по ар-деко в Саут-Бич, тур на гольф-каре по муралам Винвуда и закатный круиз мимо Стар-Айленда и небоскрёбов. В этом списке первыми идут экскурсии с лучшими отзывами."
        },
        {
          "q": "Далеко ли Эверглейдс от Майами?",
          "a": "Парки аэроглиссеров на шоссе Tamiami Trail и у Хомстеда — в 40–60 минутах езды от центра Майами и Майами-Бич. Сама прогулка длится 30–90 минут; с трансфером из Майами закладывайте четыре-шесть часов."
        },
        {
          "q": "Можно ли съездить из Майами на Ки-Уэст за один день?",
          "a": "Да, но день будет длинным: до Ки-Уэста около 260 км, примерно четыре часа по Заморскому шоссе в каждую сторону, поэтому туры выезжают рано утром и возвращаются поздно вечером, оставляя несколько часов на острове. По дороге большинство останавливается на островах Флорида-Кис."
        },
        {
          "q": "Сколько стоит морская прогулка в Майами?",
          "a": "Сборный обзорный круиз по заливу Бискейн — от 25–30 долларов с человека. Частная лодка с капитаном — примерно от 175–250 долларов за два-четыре часа на всю компанию; большие яхты с экипажем и водными развлечениями — от нескольких сотен до нескольких тысяч долларов. На карточке — цена «от»; точную цену на вашу дату и компанию покажет сайт партнёра."
        },
        {
          "q": "Когда лучше бронировать экскурсии в Майами?",
          "a": "В сухой сезон, с ноября по апрель, самая комфортная погода и самое спокойное море; это и самое загруженное время, поэтому на выходные, праздники и весенние каникулы бронируйте за несколько дней. С июня по ноябрь жарко и влажно, после обеда бывают грозы: выбирайте утренние экскурсии и до бронирования лодки проверьте условия отмены из-за погоды."
        },
        {
          "q": "Есть ли в Майами экскурсии на русском языке?",
          "a": "Немного: большинство экскурсий проходит на английском, многие — ещё и на испанском, а гиды, говорящие по-русски, встречаются редко. Язык каждой экскурсии указан в её описании на сайте партнёра."
        }
      ]
    },
    "boats": {
      "title": "Яхты и лодки",
      "short": "Морские\nпрогулки",
      "seoTitle": "Морские прогулки в Майами: Стар-Айленд и Миллионерский ряд",
      "heading": "Морские прогулки и круизы по заливу в Майами",
      "intro": "Круизы по заливу Бискейн мимо особняков Миллионерского ряда и Стар-Айленда, частные прогулки с капитаном, закатные круизы и вечеринки на воде.",
      "meta": "Морские прогулки в Майами: круизы по заливу Бискейн мимо Стар-Айленда и Миллионерского ряда, частные прогулки с капитаном, закатные круизы и вечеринки.",
      "partnerTitle": "Нужна лодка только для своих?",
      "partnerText": "Туры выше бронируются сразу. Если нужен выбор шире — частные лодки и яхты по размеру, марине и числу гостей, — на Sailo их сотни в Майами, Майами-Бич и на Ки-Бискейне.",
      "guideTitle": "Как выбрать морскую прогулку в Майами",
      "guide": [
        {
          "h": "Общий круиз или частная лодка?",
          "p": [
            "Дешевле всего выйти в море на общем обзорном круизе от Bayside Marketplace в центре: около 90 минут по заливу Бискейн мимо круизного порта, Fisher Island и особняков Стар-Айленда и Миллионерского ряда, а гид в микрофон рассказывает, чей это дом. Закатные круизы с шампанским идут похожим маршрутом вечером, а на party boat добавляются музыка и бар.",
            "Частную лодку с капитаном бронируют только для своей компании, обычно на два–шесть часов и до 12–13 человек. План выбираете вы: небоскрёбы и дома знаменитостей, купание на песчаной отмели, обед на борту или закат напротив Брикелла. Цена — за всю лодку, поэтому для компании от шести человек на каждого выходит дешевле, чем кажется."
          ]
        },
        {
          "h": "Купание и водные игрушки",
          "p": [
            "Большинство частных лодок по пути останавливаются искупаться: на одной из отмелей залива, где прозрачная вода по пояс, или у Raccoon Island — там тише, птицы и короткая прогулка по берегу. Про сами отмели — Haulover или Nixon, приливы и выходные — см. страницу «Песчаные отмели».",
            "На многих яхтах есть гидроциклы, банан, сапборды или надувной плот — иногда в цене, иногда за доплату. Читайте, что входит в стоимость: топливо, капитан, напитки, лёд и водные игрушки на разных лодках разные, а чаевые капитану (принято 15–20%) почти никогда не включены."
          ]
        },
        {
          "h": "Когда ехать и что взять",
          "p": [
            "Утром вода обычно спокойнее всего. Летом послеобеденные грозы собираются быстро, и капитан может сократить или перенести выход; большинство туров при отмене из-за погоды предлагают другую дату или возврат денег. С ноября по апрель залив в лучшей форме, и на выходные и праздники лодки разбирают заранее.",
            "Возьмите безопасный для рифов солнцезащитный крем, шляпу, полотенце и купальник под одежду и проверьте марину: лодки уходят из Майами-Бич, Bayside, с реки Майами и из Haulover. Список отсортирован по отзывам — первыми идут лодки со стабильно высокими оценками."
          ]
        }
      ],
      "faq": [
        {
          "q": "Сколько стоит частная морская прогулка в Майами?",
          "a": "Небольшая лодка с капитаном — от $175–250 за два–четыре часа на всю компанию. Яхты побольше, 45–70 футов, с экипажем и гидроциклами стоят от нескольких сотен до нескольких тысяч долларов в зависимости от размера, длительности и дня."
        },
        {
          "q": "Кто управляет лодкой на частной прогулке?",
          "a": "Лицензированный капитан — он есть на всех лодках из этого списка, так что можно отдыхать, купаться и пить на борту. Сесть за руль гидроцикла самому — другое дело, см. страницу водных развлечений."
        },
        {
          "q": "Можно ли взять с собой еду и напитки?",
          "a": "На большинство частных лодок — да: закуски, напитки и даже торт на праздник, часто с выдачей льда и холодильника. Стеклянные бутылки обычно запрещены. На общих круизах напитки продают на борту."
        },
        {
          "q": "На какой прогулке показывают дома знаменитостей?",
          "a": "Общие круизы по Миллионерскому ряду и Стар-Айленду от Bayside Marketplace построены вокруг них, с рассказом о владельцах. Большинство частных лодок тоже пройдут мимо Стар-Айленда по просьбе."
        }
      ]
    },
    "yacht-rental": {
      "title": "Аренда яхт",
      "short": "Аренда\nяхт",
      "intro": "Частные яхты с капитаном для вашей компании: небоскрёбы, Стар-Айленд и песчаная отмель в заливе Бискейн, на многих — гидроциклы.",
      "seoTitle": "Аренда яхты в Майами: частные яхты с капитаном",
      "heading": "Аренда яхт в Майами",
      "meta": "Аренда частной яхты в Майами с капитаном: яхты до 13 гостей, маршруты по заливу Бискейн, к Стар-Айленду и на песчаную отмель, гидроциклы и прогулки на закате.",
      "partnerTitle": "Больше яхт на Sailo",
      "partnerText": "На Sailo сотни моторных яхт в аренду в Майами — от 40-футовых катеров до суперъяхт с полным экипажем. Фильтры по размеру, числу гостей и марине, бронирование — на их сайте.",
      "guideTitle": "Как арендовать яхту в Майами",
      "guide": [
        {
          "h": "Что входит в аренду",
          "p": [
            "Аренда яхты в Майами — это частная лодка для вашей компании с лицензированным капитаном, обычно на три–восемь часов. Капитан ведёт яхту, встаёт на якорь и составляет маршрут вместе с вами; на больших яхтах есть матрос, который подаёт напитки и следит за водными игрушками. Топливо на обычный маршрут, лёд, вода и холодильник-контейнер обычно включены — читайте описание: иногда топливо или уборку берут отдельно.",
            "Частые допы — гидроциклы, надувной мат, сапборды или «банан», иногда включены, иногда с почасовой оплатой. Еду и напитки чаще всего берут свои (без стекла) или заказывают кейтеринг при бронировании. Чаевые экипажу в цену не входят, принято 15–20 %."
          ]
        },
        {
          "h": "Размер, гости и длительность",
          "p": [
            "Яхту выбирают по числу гостей. Большинство частных яхт в Майами берут до 12–13 человек — это предел для судна без пассажирского сертификата Береговой охраны. Поэтому яхта 37–50 футов подойдёт семье или компании друзей, а 60–70 футов даст той же компании больше палубы, тени и каюты. Для большой вечеринки нужна сертифицированная яхта, которой разрешено брать десятки гостей.",
            "Аренда обычно от трёх–четырёх часов, на многих яхтах в выходные минимум четыре. Четырёх часов хватает на небоскрёбы, Стар-Айленд и купание; за шесть–восемь можно дойти до тихой стоянки, пообедать на борту и вернуться на закате."
          ]
        },
        {
          "h": "Маршруты и сезон",
          "p": [
            "Классические маршруты начинаются в Майами-Бич, на реке Майами или у Bayside, идут мимо круизного порта, Fisher Island и особняков Стар-Айленда и Миллионерского ряда и встают на якорь у отмели Haulover или Nixon, чтобы искупаться. Долгие прогулки уходят на юг за Ки-Бискейн к Stiltsville — деревянным домам на сваях в национальном парке Бискейн — или в океан вдоль Майами-Бич.",
            "С ноября по апрель залив спокойный и сухо, а выходные бронируют заранее, особенно в праздники и во время Art Basel. Летом выходите утром: днём часто бывают грозы, и капитаны переносят или сокращают прогулку, если рядом молнии. Почти везде при отмене из-за погоды предлагают другую дату или возврат денег."
          ]
        }
      ],
      "faq": [
        {
          "q": "Нужны ли права, чтобы арендовать яхту в Майами?",
          "a": "С капитаном — нет: все яхты на этой странице идут с лицензированным капитаном, который ими управляет. Чтобы во Флориде управлять лодкой самому, родившимся 1 января 1988 года и позже нужна карточка Boating Safety Education ID или временный сертификат — его помогают получить прокатчики."
        },
        {
          "q": "Сколько человек берёт яхта?",
          "a": "Большинство частных яхт в Майами — до 12–13 гостей. Для большой компании нужна яхта с пассажирским сертификатом Береговой охраны (так называемые party boats, на десятки гостей) или две лодки, которые идут вместе."
        },
        {
          "q": "На сколько часов брать яхту?",
          "a": "Чаще всего на четыре: хватает на небоскрёбы, Стар-Айленд и остановку на песчаной отмели. У многих яхт минимум три–четыре часа; чтобы дойти до Stiltsville или провести на воде весь день, берите шесть–восемь."
        },
        {
          "q": "Нужно ли оставлять чаевые капитану?",
          "a": "Да. Чаевые почти никогда не входят в цену аренды, принято 15–20 % от её стоимости капитану и экипажу в конце прогулки."
        }
      ]
    },
    "sandbar-boat-tours": {
      "title": "Песчаные отмели",
      "short": "Песчаные\nотмели",
      "intro": "Поездки на лодке к отмелям Haulover и Nixon и на Raccoon Island: купание и прогулки по мелкой прозрачной воде залива Бискейн.",
      "seoTitle": "Песчаные отмели Майами: лодочные туры на Haulover и Nixon",
      "heading": "Туры на песчаные отмели Майами",
      "meta": "Лодочные туры на песчаные отмели Майами (sandbar): отмель Haulover и Raccoon Island на севере залива Бискейн, отмель Nixon у Ки-Бискейна, частные и групповые поездки.",
      "partnerTitle": "Своя лодка на отмель",
      "partnerText": "На Sailo есть частные лодки и яхты в районе Sunny Isles Beach, рядом с отмелью Haulover. Выберите лодку по размеру и числу гостей, уточните у владельца, заходит ли она на отмель, и забронируйте на их сайте.",
      "guideTitle": "Песчаные отмели Майами: что нужно знать",
      "guide": [
        {
          "h": "Haulover или Nixon?",
          "p": [
            "Отмель Haulover — сразу за проливом Haulover Inlet, на севере залива Бискейн между Bal Harbour и Sunny Isles Beach. Это самая людная отмель Майами: лодки стоят на якоре борт к борту в прозрачной воде по пояс, а по выходным здесь плавучая вечеринка с музыкой и сапбордами. Raccoon Island рядом — тише, с короткой прогулкой по берегу и птицами.",
            "Отмель Nixon — у Ки-Бискейна, со стороны залива; названа в честь президента, у которого там был дом. Она просторнее и обычно спокойнее Haulover, с видом на небоскрёбы. Туда обычно идут с реки Майами, от Bayside или с Ки-Бискейна."
          ]
        },
        {
          "h": "Когда ехать",
          "p": [
            "Лучше всего на отмелях в отлив в тихий солнечный день: вода мельче и прозрачнее, а в прилив может быть по грудь. Бронируя утреннюю или дневную поездку, посмотрите время отлива и спросите капитана, что он советует.",
            "В будни спокойно; в субботу и воскресенье людно и шумно, а выходные регаты Columbus Day в октябре — самая большая вечеринка залива. Летом днём быстро приходят грозы, поэтому утро надёжнее, а капитаны уходят обратно, как только рядом молнии."
          ]
        },
        {
          "h": "Как добраться и правила",
          "p": [
            "До отмелей можно добраться только на лодке. Если своей нет — присоединитесь к групповому туру или арендуйте частную лодку с капитаном: от парка Haulover, Sunny Isles Beach или Майами-Бич до отмели Haulover несколько минут.",
            "На лодке с капитаном пассажирам можно пить, но берите банки или пластик, а не стекло, и увозите весь мусор с собой. По выходным патрулируют полиция и инспекторы рыбоохраны Флориды, в том числе ловят нелегальные прогулочные лодки, — бронируйте у лицензированных перевозчиков. Нужны аквашузы для песка и водорослей и солнцезащитный крем, безопасный для рифов."
          ]
        }
      ],
      "faq": [
        {
          "q": "Можно ли дойти или доплыть до отмели Haulover?",
          "a": "Нет. Отмель в заливе напротив Haulover Inlet, вокруг глубокие каналы и много лодок, поэтому добраться можно только на лодке — с туром, на частной лодке с капитаном или на своей."
        },
        {
          "q": "Какая глубина на отмели?",
          "a": "В отлив почти на всей отмели вода от щиколотки до пояса — можно стоять и ходить. В прилив глубже, а по краям начинаются каналы, поэтому детям нужны спасательные жилеты."
        },
        {
          "q": "Можно ли пить алкоголь на отмелях Майами?",
          "a": "Пассажирам на лодке с капитаном можно, тому, кто управляет, — нет. Берите банки или пластик: стекло запрещено на большинстве лодок; в людные выходные возможны проверки полиции."
        },
        {
          "q": "Какая отмель лучше для семьи с детьми?",
          "a": "Любая в будний день утром, или поездки на Nixon и Raccoon Island — там спокойнее. Haulover в выходные — вечеринка с громкой музыкой и толпой."
        }
      ]
    },
    "helicopter-tours": {
      "title": "Полёты на вертолёте",
      "short": "Полёты на\nвертолёте",
      "intro": "Частные полёты на вертолёте и самолёте над Майами-Бич, заливом Бискейн и небоскрёбами — днём, на закате или ночью.",
      "seoTitle": "Полёты на вертолёте в Майами: обзорные туры",
      "heading": "Полёты на вертолёте в Майами",
      "meta": "Полёты на вертолёте в Майами: частные туры над Майами-Бич, Стар-Айлендом и небоскрёбами Даунтауна, закатные полёты с шампанским и обзорные полёты на самолёте.",
      "guideTitle": "Как выбрать полёт на вертолёте в Майами",
      "guide": [
        {
          "h": "Маршруты и длительность",
          "p": [
            "Большинство полётов идут вдоль побережья и залива: над Майами-Бич и Оушен-драйв, над Стар-Айлендом, Fisher Island и круизным портом, затем вокруг небоскрёбов Даунтауна и Брикелла. Длинные маршруты уходят на север к отелю Hard Rock в форме гитары в Hollywood или в сторону океана. Полёт длится от 20 минут до часа; в описании указано время в воздухе без инструктажа.",
            "Самые популярные — закатные полёты, когда небо за небоскрёбами становится оранжевым; ночные показывают город в огнях. Утром воздух обычно прозрачнее и спокойнее — хорошо для фото и для тех, кто боится болтанки."
          ]
        },
        {
          "h": "Вертолёт или самолёт?",
          "p": [
            "Вертолёт летит ниже и медленнее, может развернуться и зависнуть над видами, у него большие выпуклые окна; частные вертолёты чаще всего берут двух–трёх пассажиров. Небольшой самолёт проходит похожий маршрут быстрее и выше, обычно дешевле, и у многих обзорных самолётов крыло над кабиной, чтобы не закрывать вид.",
            "На частном полёте борт только для вашей компании, и цена — за полёт, а не за человека. Шампанское после посадки, фото и фиксированный маршрут — частые допы: читайте, что входит в описание."
          ]
        },
        {
          "h": "Перед полётом",
          "p": [
            "Вылет — из небольших аэропортов за пределами центра, а не с Майами-Бич, поэтому проверьте место вылета и заложите 30–45 минут на машине. Возьмите документ с фото; при бронировании спрашивают вес каждого пассажира — места распределяют для балансировки, есть ограничения по весу.",
            "Низкая облачность, грозы и сильный ветер отменяют полёты, чаще летом во второй половине дня; тогда предлагают другое время или возврат денег. Наденьте тёмную одежду, чтобы в окнах не было бликов, а кепки и сумки оставьте в машине."
          ]
        }
      ],
      "faq": [
        {
          "q": "Сколько стоит полёт на вертолёте в Майами?",
          "a": "Зависит от длительности и от того, частный полёт или групповой: частный оплачивается за весь борт, поэтому на двоих-троих выходит дешевле на человека. Актуальные цены операторов — на карточках выше."
        },
        {
          "q": "Сколько длится полёт на вертолёте над Майами?",
          "a": "От 20 минут для короткого круга над пляжем и небоскрёбами до часа для маршрутов до Hollywood или над океаном. Добавьте ещё час на инструктаж и дорогу до аэропорта."
        },
        {
          "q": "Стоит ли лететь на закате?",
          "a": "Это самое востребованное время — ради красок над небоскрёбами и заливом Бискейн. Бронируйте за несколько дней: закатных слотов мало, и оставьте запас на случай, если погода сдвинет полёт."
        },
        {
          "q": "Есть ли ограничение по весу?",
          "a": "Да. При бронировании спрашивают вес каждого пассажира, чтобы сбалансировать борт, и есть предел на одно место; точное значение — в описании тура или в подтверждении оператора."
        }
      ]
    },
    "everglades": {
      "title": "Эверглейдс и аэроглиссеры",
      "short": "Эверглейдс",
      "intro": "Аэроглиссеры по болотной траве, аллигаторы и дикая природа: экскурсии в Эверглейдс, в часе езды от Майами.",
      "seoTitle": "Эверглейдс из Майами: аэроглиссеры и дикая природа",
      "heading": "Экскурсии на аэроглиссере в Эверглейдс из Майами",
      "meta": "Экскурсии в Эверглейдс из Майами: частные и полуприватные аэроглиссеры, аллигаторы и шоу с животными, полдня с трансфером из отеля и национальный парк.",
      "guideTitle": "Как выбрать экскурсию в Эверглейдс",
      "guide": [
        {
          "h": "Аэроглиссер или день в парке?",
          "p": [
            "Большинство экскурсий в Эверглейдс — это поездки на аэроглиссере: плоская лодка с огромным пропеллером скользит по траве и мелководью «травяной реки» и останавливается, чтобы поискать аллигаторов, черепах и цапель. Поездка длится от 30 до 90 минут, а во многих парках на Tamiami Trail к ней добавляют шоу с аллигаторами и змеями.",
            "В большей части национального парка Эверглейдс аэроглиссеры запрещены, поэтому они ходят по его окраинам и в охраняемых зонах вокруг. Чтобы увидеть сам парк, выбирайте тур с пешей прогулкой с гидом, трамваем в Shark Valley или поездкой на электровелосипеде — такие занимают полдня или целый день из Майами."
          ]
        },
        {
          "h": "Общий, полуприватный или частный",
          "p": [
            "Большие общие аэроглиссеры берут несколько десятков пассажиров и стоят дешевле всего, часто вместе с автобусом из Майами. В полуприватных и мини-групповых поездках на лодке поменьше шесть–десять человек, и она заходит в узкие протоки. Частный аэроглиссер — только для вашей компании, и капитан останавливается там, где есть что посмотреть.",
            "Если вы на машине, бронируйте поездку прямо в парке аэроглиссеров: от центра Майами 40 минут — час езды. Без машины выбирайте тур с трансфером — в описании указано, есть ли он и откуда."
          ]
        },
        {
          "h": "Когда ехать и чего ждать",
          "p": [
            "Сухой сезон, с декабря по апрель, лучший для наблюдения за животными: они собираются у оставшейся воды, а комаров меньше. Летом болота зеленее и полноводнее, но жарко и после обеда грозы, так что лучше ехать утром. Аллигаторов видно круглый год.",
            "Аэроглиссеры очень шумные — выдают защиту для ушей — и открыты солнцу: возьмите шляпу, которую не сдует, крем от солнца и средство от насекомых. Большинство поездок подходят детям, но минимальный возраст проверьте на странице тура."
          ]
        }
      ],
      "faq": [
        {
          "q": "Сколько длится экскурсия на аэроглиссере в Эверглейдс?",
          "a": "Сама поездка — 30–90 минут. С дорогой из Майами и шоу с животными закладывайте четыре–шесть часов; туры с посещением национального парка занимают целый день."
        },
        {
          "q": "Увижу ли я аллигаторов?",
          "a": "Скорее всего, да. Аллигаторы живут в Эверглейдс круглый год, и капитаны знают, где их искать, особенно в сухой сезон с декабря по апрель. Во многих парках к тому же есть шоу с аллигаторами, так что вблизи вы их увидите в любом случае."
        },
        {
          "q": "Подходит ли экскурсия в Эверглейдс детям?",
          "a": "Да, на большинство аэроглиссеров детей берут, а шоу с животными им очень нравятся. Младенцев на некоторые лодки не пускают из-за шума — проверьте минимальный возраст на странице тура."
        },
        {
          "q": "Можно ли совместить Эверглейдс с обзорной экскурсией по Майами?",
          "a": "Да: комбинированные туры добавляют к аэроглиссеру круиз по заливу Бискейн и автобусную экскурсию по Майами за один день. Это выгодно, если мало времени, но остановки короче, чем на отдельных турах."
        }
      ]
    },
    "city-tours": {
      "title": "Город и ар-деко",
      "short": "Город\nи ар-деко",
      "intro": "Квартал ар-деко в Саут-Бич, Маленькая Гавана, муралы Винвуда и Коконат-Гроув — Майами пешком, на велосипеде или на автобусе.",
      "seoTitle": "Экскурсии по Майами: «3 в 1», пешие и на гольф-каре",
      "heading": "Обзорные экскурсии по Майами",
      "meta": "Экскурсии по Майами: туры «3 в 1» по Саут-Бич, Винвуду и Маленькой Гаване, частные поездки с гидом-водителем, пешие прогулки, гольф-кары и открытый автобус.",
      "guideTitle": "Как выбрать экскурсию по Майами",
      "guide": [
        {
          "h": "Три района за одну экскурсию",
          "p": [
            "Майами растянут, поэтому большинство туристов знакомятся с ним на экскурсии «3 в 1»: Саут-Бич с отелями ар-деко и Оушен-драйв, муралы Винвуда и Калье-Очо в Маленькой Гаване — на микроавтобусе или открытом автобусе за три–четыре часа. Это самый дешёвый способ сориентироваться в первый день: короткие остановки для фото и кубинский кофе.",
            "Чтобы как следует посмотреть один район, выбирайте экскурсию только по нему: пешую прогулку по кварталу ар-деко с гидом-архитектором, поездку на гольф-каре, багги или сегвее по стрит-арту Винвуда или гастрономическую прогулку по Маленькой Гаване."
          ]
        },
        {
          "h": "Пешком, на гольф-каре или на автобусе",
          "p": [
            "Пешие экскурсии самые подробные и длятся обычно два–два с половиной часа; отмеченные наградами туры по ар-деко добавляют неон Оушен-драйв в сумерках. Гольф-кары и багги объезжают кварталы Винвуда за час без изнуряющей жары — хороший выбор с детьми или для тех, кто не хочет много ходить. Открытые автобусы показывают больше города за раз: Брикелл, Даунтаун, Коконат-Гроув.",
            "Есть и экскурсии по местам съёмок фильмов и сериалов, самостоятельный маршрут на электровелосипеде по Корал-Гейблс и частные туры с водителем-гидом, который подстроит маршрут под вас."
          ]
        },
        {
          "h": "Советы на день",
          "p": [
            "Начинайте рано или ближе к вечеру: в Майами почти весь год жарко и влажно, а полдень — худшее время для прогулок. Наденьте удобную обувь, возьмите воду и крем от солнца. Вечерние экскурсии по Винвуду и Саут-Бич показывают неон и подсвеченные муралы.",
            "Проверьте место встречи: экскурсии начинаются в Майами-Бич, Винвуде или Даунтауне, и трансфер из отеля есть не везде. Список отсортирован по отзывам — первыми идут экскурсии со стабильно высокими оценками."
          ]
        }
      ],
      "faq": [
        {
          "q": "Какая экскурсия по Майами лучшая?",
          "a": "Для первого знакомства тур «3 в 1» по Саут-Бич, Винвуду и Маленькой Гаване покрывает главное за полдня. Если хочется глубже, путешественники выше всего оценивают пешую экскурсию по ар-деко в Майами-Бич и тур по стрит-арту Винвуда на гольф-каре."
        },
        {
          "q": "Сколько длится экскурсия по Майами?",
          "a": "Туры на гольф-каре и сегвее по Винвуду — от часа до полутора, пешие — два–два с половиной часа, полные обзорные на автобусе — три–четыре часа."
        },
        {
          "q": "Есть ли трансфер из отеля?",
          "a": "У части экскурсий есть, особенно у автобусных и частных; пешие туры и туры на гольф-каре обычно встречаются в точке в районе. Это указано на странице тура."
        },
        {
          "q": "Есть ли экскурсии на русском?",
          "a": "Русскоязычных гидов в Майами мало: большинство экскурсий идут на английском, многие ещё и на испанском. Языки каждой экскурсии указаны на сайте партнёра."
        }
      ]
    },
    "day-trips": {
      "title": "Ки-Уэст и поездки на день",
      "short": "Ки-Уэст\nи поездки",
      "intro": "День по Заморскому шоссе до Ки-Уэста — или в Эверглейдс, Форт-Лодердейл и на Флорида-Кис.",
      "seoTitle": "Поездки из Майами на день: Ки-Уэст, космический центр",
      "heading": "Поездки на день из Майами: Ки-Уэст и не только",
      "meta": "Поездки на день из Майами: Ки-Уэст через Флорида-Кис и Семимильный мост, Космический центр Кеннеди, Палм-Бич и Форт-Лодердейл — в мини-группе или частным образом.",
      "guideTitle": "Как выбрать поездку на день из Майами",
      "guide": [
        {
          "h": "Ки-Уэст и Флорида-Кис",
          "p": [
            "Классическая поездка идёт по Заморскому шоссе, которое перепрыгивает с острова на остров над морем: Ки-Ларго, Исламорада, Семимильный мост и, наконец, Ки-Уэст — примерно в 160 милях от Майами. Это около четырёх часов в одну сторону, поэтому туры выезжают в 6–7 утра и возвращаются поздно вечером, а на острове остаётся три–четыре часа: самая южная точка США, Дюваль-стрит, дом Хемингуэя и, в длинных турах, закат на площади Мэллори.",
            "Мини-группы в микроавтобусах, примерно до 14 человек, останавливаются на Кис для фото и завтрака; частные туры с водителем позволяют выбирать остановки и темп самим."
          ]
        },
        {
          "h": "На север: космический центр, Палм-Бич и Форт-Лодердейл",
          "p": [
            "Космический центр Кеннеди на мысе Канаверал — примерно в трёх с половиной часах к северу, поэтому поездка занимает около 12 часов; в комплексе для посетителей есть «Сатурн-5» и шаттл «Атлантис», а если запланирован запуск, можно его увидеть. Палм-Бич в полутора часах — день поспокойнее: особняки острова, музей Флаглера и отель The Breakers, часто вместе с каналами и пляжем Форт-Лодердейла.",
            "Эверглейдс — меньше часа езды и полдня — смотрите на странице Эверглейдс."
          ]
        },
        {
          "h": "Мини-группа или частный тур?",
          "p": [
            "Туры в мини-группе дешевле и включают дорогу и гида; входные билеты, еда и активности в Ки-Уэсте или в космическом центре часто оплачиваются отдельно, так что сравнивайте, что входит в цену. Частные туры заметно дороже, но цена — за всю машину или внедорожник, поэтому для семьи или компании друзей они вполне разумны.",
            "Оденьтесь удобно для долгой дороги, возьмите перекус и купальник, если тур останавливается на пляже, и накануне уточните место и время сбора."
          ]
        }
      ],
      "faq": [
        {
          "q": "Стоит ли ехать из Майами в Ки-Уэст на один день?",
          "a": "Если нет возможности остаться на ночь — да: дорога через Кис сама по себе часть впечатления. Но это долгий день, около 12 часов, из них восемь в машине; если время есть, переночевать в Ки-Уэсте спокойнее."
        },
        {
          "q": "Как далеко Ки-Уэст от Майами?",
          "a": "Около 160 миль, или примерно четыре часа по Заморскому шоссе без остановок. Туры едут дольше, потому что по пути останавливаются на Кис."
        },
        {
          "q": "Можно ли съездить в Космический центр Кеннеди из Майами за день?",
          "a": "Да, туры из Майами занимают около 12 часов: примерно по три с половиной часа в каждую сторону и пять–шесть часов в комплексе. Проверьте, включён ли входной билет."
        },
        {
          "q": "Что входит в поездку на день?",
          "a": "Дорога и водитель или гид входят всегда; входные билеты, еда и активности зависят от тура. На странице каждого тура указано, что включено, а что нет."
        }
      ]
    },
    "water-sports": {
      "title": "Водные развлечения",
      "short": "Водные\nразвлечения",
      "intro": "Гидроциклы в заливе Бискейн, сапбординг, снорклинг и парасейлинг у Майами-Бич.",
      "seoTitle": "Водные развлечения в Майами: гидроциклы, банан и другое",
      "heading": "Водные развлечения в Майами",
      "meta": "Водные развлечения в Майами: гидроциклы с гидом по заливу Бискейн, яхты с гидроциклами, банан и тюбинг, вейксёрф, уроки водных лыж и джет-кары.",
      "guideTitle": "Как выбрать водные развлечения в Майами",
      "guide": [
        {
          "h": "Гидроциклы по заливу Бискейн",
          "p": [
            "Гидроцикл — самое популярное водное развлечение Майами. На туре с гидом вы около часа едете за ним по заливу мимо небоскрёбов, Стар-Айленда и домов знаменитостей, с остановками для фото; обычно на одном гидроцикле один–два человека. Прокат в отведённой зоне у марины короче и дешевле, но из этой зоны вы не выезжаете.",
            "Закон Флориды устанавливает минимальный возраст для управления гидроциклом, а всем, кто родился 1 января 1988 года или позже, нужен сертификат о безопасности на воде — прокатная компания выдаёт временный перед выходом. Возьмите документ с фото и будьте готовы к возвратному депозиту."
          ]
        },
        {
          "h": "Яхты с игрушками, банан и джет-кары",
          "p": [
            "Для компании яхта, к которой прилагаются один–два гидроцикла, банан или тюбинг, совмещает прогулку с катанием; на некоторых party boat есть бар. Ещё есть вейксёрф за специальной лодкой, уроки водных лыж для новичков и джет-кары — небольшие катера в виде спорткара, которыми управляете вы сами.",
            "Некоторые туры совмещают гидроцикл с квадроциклом или конной прогулкой на суше — полдня активностей."
          ]
        },
        {
          "h": "Сборы, погода и безопасность",
          "p": [
            "Перед бронированием проверьте итоговую цену: топливо, доставка на лодке до зоны гидроциклов, жилеты и налоги могут быть включены или взиматься на месте, а предложения с пометкой «все сборы включены» проще сравнивать. Чаевые гиду приняты.",
            "Утром вода спокойнее. Летние послеобеденные грозы могут остановить катание в последний момент, и большинство компаний тогда предлагают другое время или возврат. Приходите в купальнике, возьмите очки на шнурке, а ценные вещи оставьте на берегу."
          ]
        }
      ],
      "faq": [
        {
          "q": "Сколько стоит тур на гидроцикле в Майами?",
          "a": "Часовой тур с гидом — примерно $85–190 за гидроцикл, в зависимости от компании и того, какие сборы включены. Яхты с гидроциклами оцениваются за всю компанию."
        },
        {
          "q": "Нужны ли права на гидроцикл в Майами?",
          "a": "Прав не нужно, но всем, кто родился 1 января 1988 года или позже, нужен флоридский сертификат о безопасности на воде; прокат выдаёт временный на месте после короткого теста. Есть и минимальный возраст водителя — проверьте его на странице тура."
        },
        {
          "q": "Можно ли кататься вдвоём на одном гидроцикле?",
          "a": "Да, большинство гидроциклов рассчитаны на двоих, а некоторые туры берут плату за гидроцикл, а не за человека, так что вдвоём дешевле."
        },
        {
          "q": "Подходят ли водные развлечения детям?",
          "a": "Дети обычно могут ехать пассажирами со взрослым, а банан и тюбинг очень нравятся подросткам. Минимальный возраст зависит от развлечения и компании — он указан на странице каждого тура."
        }
      ]
    },
    "attractions": {
      "title": "Достопримечательности и билеты",
      "short": "Билеты",
      "intro": "Билеты в музеи, сады, зоопарки и парки Майами — Вискайя, музей науки Фроста, зоопарк Майами и другие.",
      "seoTitle": "Достопримечательности Майами: музеи, зоопарк, Вискайя",
      "heading": "Достопримечательности и билеты в Майами",
      "meta": "Билеты на достопримечательности Майами: Вискайя, Superblue, PAMM, музей науки Фроста, зоопарк Майами, Jungle Island, музей Paradox, Wynwood Walls и пропуска Go City.",
      "guideTitle": "Как выбрать достопримечательности в Майами",
      "guide": [
        {
          "h": "Искусство, музеи и сады",
          "p": [
            "Музеи Майами собраны в нескольких районах. В Винвуде Wynwood Walls показывают муралы художников со всего мира — вход по времени, есть экскурсии с гидом, — а Музей граффити рассказывает историю стрит-арта. В центре Музей искусств Переса (PAMM) и музей науки Фроста с аквариумом и планетарием стоят рядом в Музейном парке на берегу залива, в паре шагов от Башни свободы.",
            "Вискайя — вилла в итальянском стиле 1910-х годов с регулярным садом на берегу залива в Коконат-Гроув — самое изысканное место Майами; поместье Диринга южнее сочетает исторический дом с природными тропами. Superblue — это иммерсивное искусство из света и звука, а музей Paradox и Музей мороженого — весёлые и фотогеничные остановки."
          ]
        },
        {
          "h": "Животные и семейные дни",
          "p": [
            "Зоопарк Майами на юге округа — большой зоопарк под открытым небом, на который нужно полдня; в жару выручают трамвайчик или велосипед. Jungle Island на острове Уотсон, между Даунтауном и Майами-Бич, — птицы, встречи с животными и шоу. Для целого дня с детьми смотрите страницу «С детьми»."
          ]
        },
        {
          "h": "Билеты и пропуска",
          "p": [
            "Билет онлайн избавляет от очереди, а в Wynwood Walls, Superblue и Музей мороженого гарантирует время входа — по выходным и в высокий сезон их раскупают. Пропуск Go City объединяет несколько достопримечательностей и туров за одну цену; он окупается, если за несколько дней вы планируете три и больше мест из его списка.",
            "Учитывайте дорогу между районами: от центра до Вискайи около 15 минут на машине, до зоопарка — 40. Список отсортирован по отзывам."
          ]
        }
      ],
      "faq": [
        {
          "q": "Что обязательно посмотреть в Майами?",
          "a": "Любимые места путешественников — Wynwood Walls, музей и сады Вискайя, PAMM и музей науки Фроста в Музейном парке, а также квартал ар-деко в Саут-Бич, который можно посмотреть бесплатно или с экскурсией."
        },
        {
          "q": "Нужно ли заранее покупать билеты в Wynwood Walls?",
          "a": "Желательно: вход по временным слотам, и вечера выходных заполняются. С билетом, купленным онлайн, вы проходите сразу в своё время."
        },
        {
          "q": "Стоит ли брать пропуск Go City Miami?",
          "a": "Он экономит деньги, если за срок действия посетить хотя бы три включённых в него места или тура. Сначала составьте план и сравните с ценами отдельных билетов."
        },
        {
          "q": "Какие достопримечательности Майами подходят для дождливого дня?",
          "a": "Музей науки Фроста, PAMM, Superblue, музей Paradox, Музей мороженого и Музей граффити — все в помещении, хороший выбор для летней грозы после обеда."
        }
      ]
    },
    "family": {
      "title": "С детьми",
      "short": "С детьми",
      "intro": "Чем заняться в Майами с детьми: дикая природа, спокойные морские прогулки, аквариумы и парки для любого возраста.",
      "seoTitle": "Майами с детьми: зоопарк, музей науки и другое",
      "heading": "Чем заняться в Майами с детьми",
      "meta": "Майами с детьми: зоопарк Майами, Jungle Island, музей науки Фроста с аквариумом, Музей мороженого и пропуска на достопримечательности для всей семьи.",
      "guideTitle": "Как спланировать день с детьми в Майами",
      "guide": [
        {
          "h": "Животные и наука",
          "p": [
            "Зоопарк Майами — это целый день: большой зоопарк под открытым небом на юге округа, с животными Азии, Африки и Америки в просторных вольерах. На него нужно четыре часа и больше, так что приезжайте к открытию, пока не жарко. Jungle Island на острове Уотсон меньше и ближе к пляжам: попугаи, лемуры, встречи с животными и шоу.",
            "Музей науки Фроста в центре подходит для любого возраста и любой погоды: трёхэтажный аквариум с акулами и скатами, планетарий и интерактивные выставки о теле человека и полёте. Музей мороженого — сладкая и весёлая остановка для малышей, с бассейном из цветной посыпки и дегустациями."
          ]
        },
        {
          "h": "Не только билеты",
          "p": [
            "Детям подходят и многие развлечения из других разделов. Аэроглиссер в Эверглейдс с шоу аллигаторов обожают школьники, круиз по заливу Бискейн — лёгкий час на воде, а туры на гольф-каре по Винвуду показывают муралы без долгой ходьбы.",
            "Если планируете несколько мест, пропуск Go City Explorer позволяет выбрать от двух до пяти за одну цену."
          ]
        },
        {
          "h": "Советы для семей",
          "p": [
            "Прогулки на улице оставьте на утро, а музеи — на вторую половину дня, когда жара в пике и приходят летние грозы. Детские билеты обычно дешевле, а малыши часто проходят бесплатно — возрастные границы указаны на странице каждого билета. Возьмите воду, крем от солнца, панамки и коляску для зоопарка."
          ]
        }
      ],
      "faq": [
        {
          "q": "Чем заняться в Майами с маленькими детьми?",
          "a": "Проще всего с малышами в Jungle Island, аквариуме музея Фроста и Музее мороженого: недолгие визиты, тень или кондиционер и много всего, что можно потрогать и посмотреть."
        },
        {
          "q": "Сколько времени нужно на зоопарк Майами?",
          "a": "Закладывайте четыре–шесть часов: зоопарк большой, и переходы между зонами занимают время. С детьми выручают трамвайчик или арендованные велосипеды."
        },
        {
          "q": "Подходит ли музей науки Фроста детям?",
          "a": "Да: аквариум, планетарий и интерактивные выставки занимают детей любого возраста на два–три часа — хороший план на дождливый или очень жаркий день."
        },
        {
          "q": "Детские билеты дешевле?",
          "a": "Обычно да, а маленькие дети часто проходят бесплатно. Возрастные границы у разных мест разные и указаны на странице каждого билета."
        }
      ]
    },
    "date-night": {
      "title": "Вечер вдвоём",
      "intro": "Закатные круизы, ужины с видом и вечера для двоих в Майами.",
      "seoTitle": "Романтика в Майами: закатные круизы и полёты",
      "heading": "Вечер вдвоём в Майами",
      "meta": "Романтика в Майами: закатные круизы с шампанским по заливу Бискейн, частные яхты на двоих и полёты на закате над Майами-Бич.",
      "guideTitle": "Как спланировать романтический вечер в Майами",
      "guide": [
        {
          "h": "Закат на воде",
          "p": [
            "Самый простой романтический план в Майами — закатный круиз: час-два по заливу Бискейн, пока небо за башнями Брикелла становится оранжевым, с бокалом шампанского. Общие круизы с шампанским от Bayside недорогие и непринуждённые; частная лодка на двоих с капитаном и бутылкой во льду — версия поуединённее, она может встать в самом тихом уголке залива.",
            "Рассчитайте время: зимой солнце садится около 17:30–18:00, летом — после 20:00, и большинство туров подстраивают закатный выход под сезон."
          ]
        },
        {
          "h": "Майами с высоты",
          "p": [
            "Частный полёт на вертолёте или небольшом самолёте над Майами-Бич, островами и небоскрёбами — свидание, которое трудно забыть. Полёты длятся 30–60 минут, во многие входит шампанское после посадки, а закатные и ночные показывают город в огнях. Самолёт дешевле вертолёта на похожем маршруте.",
            "Взлетают из аэропортов за пределами центра — заложите время на дорогу; обычно действует ограничение по весу пассажира. Маршруты и длительность — на странице «Полёты на вертолёте»."
          ]
        },
        {
          "h": "Советы на вечер",
          "p": [
            "На пятницу и субботу бронируйте за несколько дней и оставьте конец вечера свободным для ужина в Брикелле, Винвуде или Саут-Бич. Летние грозы могут задержать закатный круиз или полёт; большинство туров предлагают другую дату или возврат."
          ]
        }
      ],
      "faq": [
        {
          "q": "Что самое романтичное в Майами?",
          "a": "Частный закатный круиз по заливу Бискейн с шампанским или закатный полёт на вертолёте над Майами-Бич — их пары оценивают выше всего."
        },
        {
          "q": "Сколько стоит закатный круиз на двоих в Майами?",
          "a": "Общий круиз с шампанским — примерно $25–95 с человека. Частная лодка на двоих с капитаном — от $200–250 за два часа."
        },
        {
          "q": "Во сколько закат в Майами?",
          "a": "Около 17:30–18:00 в декабре и январе и около 20:15 в июне и июле. Туры назначают закатный выход по сезону."
        },
        {
          "q": "Можно ли сделать предложение на частной лодке или в полёте?",
          "a": "Да, многие капитаны и пилоты к этому привыкли: скажите при бронировании и спросите про цветы, украшения или фотографа — некоторые туры предлагают их за доплату."
        }
      ]
    },
    "beach-days": {
      "title": "Пляжный день",
      "intro": "Майами-Бич, Ки-Бискейн и лучшие дни на песке и на воде.",
      "seoTitle": "Пляжный день в Майами: лучшие пляжи и купание",
      "heading": "Пляжный день в Майами",
      "meta": "Как провести пляжный день в Майами: Саут-Бич, Ки-Бискейн и Haulover, купание у островов с лодки и туры с пляжами Форт-Лодердейла.",
      "guideTitle": "Как провести пляжный день в Майами",
      "guide": [
        {
          "h": "Какой пляж для какого дня",
          "p": [
            "Самый известный — Саут-Бич: широкий песок, вышки спасателей и Оушен-драйв за спиной, кафе и души в двух шагах. За спокойной мелкой водой — на Ки-Бискейн: Crandon Park с тенью и площадками для пикника и Bill Baggs с маяком, или на север, в парк Haulover и Sunny Isles, где в будни тихо.",
            "Некоторые туры на минивэне совмещают пляжи Майами с Форт-Лодердейлом или Палм-Бич — день вдоль побережья. Без машины проще всего добраться до Саут-Бича на автобусе или такси."
          ]
        },
        {
          "h": "Купание с лодки",
          "p": [
            "Другой вариант пляжного дня — на заливе: прогулка на лодке с купанием у маленького острова или на отмели, где вода прозрачная, тёплая и мелкая. Туры на Raccoon Island добавляют короткую прогулку по берегу и птиц; на частной лодке компания остаётся сколько хочет. Про сами отмели — Haulover и Nixon, приливы и выходные — отдельная страница: «Песчаные отмели»."
          ]
        },
        {
          "h": "Солнце, флаги и водоросли",
          "p": [
            "Солнце во Флориде сильное круглый год: возьмите безопасный для рифов крем, шляпу и много воды, а в полдень ищите тень. На городских пляжах купайтесь рядом с вышкой спасателей и смотрите на цвет флага — он предупреждает о течениях.",
            "С весны до конца лета на пляжи иногда выносит саргассовые водоросли; отмели в заливе обычно страдают меньше. Поездки на лодке при грозе переносят или возвращают деньги."
          ]
        }
      ],
      "faq": [
        {
          "q": "Пляжи в Майами бесплатные?",
          "a": "Да, городские пляжи Майами и Майами-Бич бесплатные. Платить нужно за парковку, а также за лежаки и зонты там, где их сдают; в Crandon Park и Bill Baggs на Ки-Бискейне берут плату за въезд или парковку с машины."
        },
        {
          "q": "Какой пляж Майами лучше для семьи?",
          "a": "В Crandon Park на Ки-Бискейне спокойная мелкая вода, тень и вся инфраструктура. Саут-Бич оживлённее, а парк Haulover и Sunny Isles на севере тише."
        },
        {
          "q": "Можно ли купаться на морской прогулке в Майами?",
          "a": "Да, на большинстве частных лодок и поездок на отмели или острова есть остановки для купания. На общих обзорных круизах от Bayside — нет."
        },
        {
          "q": "Когда лучше всего ехать на пляж в Майами?",
          "a": "Вода тёплая почти весь год. С ноября по апрель сухо и комфортно; летом жарче и после обеда грозы, так что лучше утром."
        }
      ]
    },
    "luxury": {
      "title": "Роскошный отдых",
      "intro": "Частные яхты, гидросамолёты и эксклюзивные экскурсии — Майами по высшему разряду.",
      "seoTitle": "Роскошный отдых в Майами: частные яхты, полёты и VIP-туры",
      "heading": "Роскошный отдых в Майами",
      "meta": "Роскошный отдых в Майами: частные яхты с экипажем, круизы с шампанским, частные обзорные полёты, ралли на суперкарах и VIP-экскурсии по городу.",
      "guideTitle": "Как выбрать роскошные впечатления в Майами",
      "guide": [
        {
          "h": "В воздухе",
          "p": [
            "Частные полёты на вертолёте и самолёте над Майами-Бич, островами залива Бискейн и небоскрёбами — главная роскошь Майами, особенно на закате и с шампанским. Маршруты, длительность и что проверить перед вылетом — на странице «Полёты на вертолёте»."
          ]
        },
        {
          "h": "На воде и на дороге",
          "p": [
            "Частная яхта с экипажем — классический способ стильно провести день в Майами: обед и напитки на борту, купание на отмели и дома знаменитостей Стар-Айленда, а на больших яхтах — гидроциклы. Спокойнее — электролодка по реке Майами с вином и закусками или закатный круиз с шампанским.",
            "На суше — частные туры на целый день, объединяющие город и лодку с персональным гидом, тур на люксовом минивэне по пляжам и районам и ралли на суперкарах до Ки-Уэста и обратно за 24 часа."
          ]
        },
        {
          "h": "Перед бронированием",
          "p": [
            "За яхты и полёты платят за частное впечатление, а не с человека; проверьте, что включено — напитки, кейтеринг, чаевые экипажу, трансфер, — и ограничения по числу пассажиров, включая вес на вертолётах. На выходные, Art Basel в декабре и праздники бронируйте за неделю и раньше."
          ]
        }
      ],
      "faq": [
        {
          "q": "Что ещё из роскошного, кроме яхт и полётов?",
          "a": "Ралли на суперкарах до Ки-Уэста и обратно за 24 часа, частные экскурсии на целый день — город и лодка с личным гидом, тур на люксовом минивэне по пляжам и районам и электролодка по реке Майами с вином и закусками."
        },
        {
          "q": "Как увидеть Майами с максимальным комфортом?",
          "a": "Частная яхта с экипажем по заливу Бискейн, а потом закатный полёт на вертолёте над Майами-Бич — такое сочетание выбирают многие."
        },
        {
          "q": "Включены ли напитки в роскошные круизы?",
          "a": "В круизах с шампанским — да, оно в цене; на частных яхтах зависит от аренды: где-то бар включён, где-то можно взять своё. Смотрите страницу тура."
        },
        {
          "q": "Нужно ли бронировать заранее?",
          "a": "Да, особенно на выходные и в высокий сезон с декабря по апрель: у частных яхт и вертолётов мало слотов, и лучшие разбирают первыми."
        }
      ]
    },
    "art-and-culture": {
      "title": "Искусство и культура",
      "intro": "Стрит-арт Винвуда, архитектура ар-деко, Маленькая Гавана и музеи Майами.",
      "seoTitle": "Искусство и культура Майами: музеи, галереи, история",
      "heading": "Искусство и культура Майами",
      "meta": "Искусство и культура Майами: музеи и галереи, Дизайн-дистрикт, экскурсии по архитектуре и истории, кубинское наследие и уличное искусство города.",
      "guideTitle": "Искусство и культура Майами",
      "guide": [
        {
          "h": "Стрит-арт и дизайн",
          "p": [
            "Винвуд — сердце художественной жизни Майами: бывшие склады, покрытые муралами, вокруг Wynwood Walls, галереи, пивоварни и кафе. Экскурсии идут пешком, на гольф-каре или багги, на сегвее или с уличным художником в роли гида, а некоторые совмещают муралы с дегустациями или мастер-классом по граффити. По соседству Дизайн-дистрикт смешивает люксовые бутики с паблик-артом и архитектурой, а Литл-Ривер — новый творческий квартал.",
            "Art Basel Miami Beach в начале декабря превращает весь город в арт-ярмарку, с десятками сопутствующих ярмарок и новыми муралами, — самая людная и дорогая неделя года."
          ]
        },
        {
          "h": "Ар-деко и кубинский Майами",
          "p": [
            "В Саут-Бич — одно из крупнейших в мире собраний зданий ар-деко: пастельные отели 1930-х с неоновыми вывесками, окнами-иллюминаторами и полами из терраццо. Экскурсии рассказывают о стиле и о борьбе, которая спасла квартал от сноса, а музей Вулфсониан показывает дизайн той эпохи.",
            "В Маленькой Гаване Калье-Очо — центр кубинского Майами: сигарная фабрика, где сигары крутят вручную, парк домино, кубинский кофе из уличного окошка и живая музыка. Гастрономические туры дают попробовать классику — от кубинского сэндвича до пирожков с гуавой."
          ]
        },
        {
          "h": "Музеи",
          "p": [
            "В помещении: PAMM на берегу залива с современным искусством, Superblue с иммерсивными инсталляциями, Вискайя — историческая вилла с садами, и Башня свободы, рассказывающая историю кубинской эмиграции. Многие экскурсии из этого списка идут ещё и на испанском или французском."
          ]
        }
      ],
      "faq": [
        {
          "q": "Вход в Винвуд бесплатный?",
          "a": "По улицам и мимо большинства муралов гулять бесплатно. В Wynwood Walls — центральный сад муралов — нужен билет на время; экскурсии с гидом рассказывают о художниках и районе."
        },
        {
          "q": "Какая экскурсия по ар-деко в Майами-Бич лучшая?",
          "a": "Выше всего оценивают отмеченные наградами пешие экскурсии по ар-деко, включая вечернюю с неоном; частные туры с гидом-архитектором уходят в детали."
        },
        {
          "q": "Чем заняться в Маленькой Гаване?",
          "a": "Пройтись по Калье-Очо, посмотреть на игроков в домино, зайти на сигарную фабрику, выпить кубинский кофе и попробовать кубинскую кухню; дегустационный тур с местным гидом укладывает всё в два–три часа."
        },
        {
          "q": "Когда проходит Art Basel Miami Beach?",
          "a": "Каждый год в начале декабря. Отели и экскурсии раскупают, цены растут — если едете в эти дни, планируйте заранее."
        }
      ]
    },
    "south-beach": {
      "title": "Саут-Бич",
      "intro": "Оушен-драйв, квартал ар-деко и пляж — чем заняться в Саут-Бич.",
      "seoTitle": "Чем заняться в Саут-Бич: экскурсии по ар-деко и другое",
      "heading": "Чем заняться в Саут-Бич, Майами-Бич",
      "meta": "Чем заняться в Саут-Бич: пешие экскурсии по ар-деко на Оушен-драйв, вечерние неоновые туры, Линкольн-роуд и Эспаньола-уэй, музей Вулфсониан и прогулки на лодке.",
      "guideTitle": "Саут-Бич: что посмотреть",
      "guide": [
        {
          "h": "Квартал ар-деко",
          "p": [
            "Саут-Бич, южная оконечность Майами-Бич, построен вокруг квартала ар-деко: сотни пастельных отелей и жилых домов 1920–40-х годов вдоль Оушен-драйв, Коллинз-авеню и Вашингтон-авеню, с горизонтальными полосами, окнами-иллюминаторами и неоном. Пешая экскурсия с гидом, которая начинается у Art Deco Welcome Center на Оушен-драйв, объясняет, как родился стиль и как квартал спасли от сноса в 1970–80-х.",
            "Вечерние туры показывают зажжённый неон, есть экскурсии на французском и на велосипеде, а музей Вулфсониан добавляет декоративное искусство той эпохи."
          ]
        },
        {
          "h": "Не только Оушен-драйв",
          "p": [
            "Линкольн-роуд — пешеходная улица магазинов и кафе, а Эспаньола-уэй с арками в средиземноморском стиле полна ресторанов. Пляж широкий и бесплатный, с теми самыми цветными вышками спасателей; из парка Саут-Пойнт на самом краю видно, как круизные лайнеры уходят по каналу Гавернмент-Кат.",
            "Несколько обзорных экскурсий совмещают Саут-Бич с Винвудом и Маленькой Гаваной за полдня, а некоторые парусные прогулки уходят из марин Саут-Бич."
          ]
        },
        {
          "h": "Советы",
          "p": [
            "Гуляйте утром или ближе к вечеру, чтобы не попасть в полуденную жару, и вернитесь на Оушен-драйв после заката ради неона. Парковка дорогая — проще такси через приложение или бесплатный трамвайчик-троллейбус Майами-Бич."
          ]
        }
      ],
      "faq": [
        {
          "q": "Чем знаменит Саут-Бич?",
          "a": "Архитектурой ар-деко, пляжем с цветными вышками спасателей, ночной жизнью на Оушен-драйв и Вашингтон-авеню и магазинами Линкольн-роуд."
        },
        {
          "q": "Сколько длится пешая экскурсия по ар-деко?",
          "a": "Обычно два–два с половиной часа, по Оушен-драйв и соседним улицам. Есть и короткие обзорные, и частные экскурсии."
        },
        {
          "q": "Саут-Бич и Майами-Бич — одно и то же?",
          "a": "Саут-Бич — южная часть Майами-Бич, отдельного города на барьерном острове по другую сторону залива Бискейн от Майами. Большая часть квартала ар-деко находится там."
        },
        {
          "q": "Можно ли обойти Саут-Бич пешком?",
          "a": "Да: квартал ар-деко, Линкольн-роуд и Эспаньола-уэй — в пределах 20 минут ходьбы друг от друга, а по Майами-Бич ходит бесплатный трамвайчик."
        }
      ]
    },
    "wynwood": {
      "title": "Винвуд",
      "intro": "Стрит-арт, галереи и пивоварни — чем заняться в Винвуде.",
      "seoTitle": "Чем заняться в Винвуде: стрит-арт и Wynwood Walls",
      "heading": "Чем заняться в Винвуде, Майами",
      "meta": "Чем заняться в Винвуде: экскурсии по стрит-арту на гольф-каре, багги и сегвее, билеты в Wynwood Walls, гастрономические туры, пивоварни и Дизайн-дистрикт.",
      "guideTitle": "Винвуд: что посмотреть",
      "guide": [
        {
          "h": "Муралы и Wynwood Walls",
          "p": [
            "Винвуд, бывший складской район чуть севернее центра, — одна из крупнейших в мире галерей стрит-арта под открытым небом: сотни муралов покрывают его стены, и каждый год появляются новые, особенно к Art Basel в декабре. В его центре Wynwood Walls — платный сад муралов художников со всего мира: билеты с прямым входом, ранний доступ и посещение после закрытия, мастер-классы по граффити."
          ]
        },
        {
          "h": "Как его посмотреть",
          "p": [
            "Гольф-кары и багги — самый популярный способ увидеть Винвуд: час по кварталам с гидом, который знает художников, под крышей от солнца. Туры на сегвее проезжают около четырёх миль, а пешие идут медленнее и глубже — некоторые ведёт уличный художник или проводят на французском. После заката ночной тур на гольф-каре показывает подсвеченные муралы.",
            "Гастрономические туры добавляют дегустации в ресторанах Винвуда, а пивной тур заезжает в местные крафтовые пивоварни. По соседству Дизайн-дистрикт с паблик-артом, архитектурой и дизайнерскими бутиками, а севернее — творческий квартал Литл-Ривер."
          ]
        },
        {
          "h": "Советы",
          "p": [
            "Приходите утром или вечером, а не в полдень, и наденьте удобную обувь. На выходные бронируйте Wynwood Walls заранее."
          ]
        }
      ],
      "faq": [
        {
          "q": "Сколько времени нужно на Винвуд?",
          "a": "Экскурсия на гольф-каре с гидом занимает около часа; с Wynwood Walls, обедом и прогулкой закладывайте полдня."
        },
        {
          "q": "Нужен ли билет в Винвуд?",
          "a": "По району гулять бесплатно, а в Wynwood Walls нужен билет на определённое время."
        },
        {
          "q": "Безопасно ли в Винвуде?",
          "a": "Центральные улицы вокруг Wynwood Walls многолюдны днём и вечером, гулять там нормально; как и в любом городе, ночью держитесь главных улиц и присматривайте за вещами."
        },
        {
          "q": "Как лучше всего посмотреть муралы Винвуда?",
          "a": "Выше всего путешественники оценивают тур на гольф-каре в мини-группе: главные муралы за час, с гидом, который рассказывает о художниках, и без ходьбы по жаре."
        }
      ]
    },
    "little-havana": {
      "title": "Маленькая Гавана",
      "intro": "Калье-Очо, кубинская кухня, сигары и домино — чем заняться в Маленькой Гаване.",
      "seoTitle": "Чем заняться в Маленькой Гаване: еда и сигары",
      "heading": "Чем заняться в Маленькой Гаване, Майами",
      "meta": "Чем заняться в Маленькой Гаване: гастрономические туры по Калье-Очо, сигарная фабрика, кубинский кофе и парк домино, обзорные экскурсии с Маленькой Гаваной.",
      "guideTitle": "Маленькая Гавана: что посмотреть",
      "guide": [
        {
          "h": "Калье-Очо",
          "p": [
            "Маленькая Гавана к западу от центра выросла из кубинских эмигрантов, приезжавших с 1960-х, а Калье-Очо — Юго-Западная 8-я улица — её главная улица. На нескольких кварталах — парк домино, где пожилые кубинцы играют под деревьями, театр «Тауэр», звёзды Аллеи славы латиноамериканских артистов, фруктовые лотки, галереи и «вентанитас» — уличные окошки, где продают крошечные чашки сладкого кубинского кофе."
          ]
        },
        {
          "h": "Еда, сигары и музыка",
          "p": [
            "Лучше всего начать с дегустационного тура: два–три часа с местным гидом, кубинский сэндвич, крокеты, эмпанадас, пирожки с гуавой и свежие соки — и история района. На сигарной фабрике показывают, как сигары крутят вручную, а вечером в барах Калье-Очо играют живую кубинскую музыку и сальсу.",
            "В последнюю пятницу каждого месяца фестиваль Viernes Culturales превращает Калье-Очо в уличный праздник с музыкой и искусством."
          ]
        },
        {
          "h": "Вместе с другими районами",
          "p": [
            "Маленькая Гавана — постоянная остановка полудневных обзорных экскурсий, которые охватывают ещё Саут-Бич и Винвуд, а некоторые длинные туры совмещают её с Эверглейдс. Отдельный гастрономический тур даёт гораздо больше времени на Калье-Очо."
          ]
        }
      ],
      "faq": [
        {
          "q": "Чем знаменита Маленькая Гавана?",
          "a": "Кубинской культурой: Калье-Очо, парк домино, сигары ручной скрутки, кубинский кофе и кухня, живая латиноамериканская музыка."
        },
        {
          "q": "Сколько времени провести в Маленькой Гаване?",
          "a": "Двух–трёх часов хватит на прогулку по Калье-Очо с кофе и обедом; гастрономический тур с гидом хорошо заполняет это время."
        },
        {
          "q": "Нужно ли знать испанский в Маленькой Гаване?",
          "a": "Нет, в магазинах и ресторанах говорят по-английски, хотя на улице звучит испанский, а гиды многих туров говорят на обоих языках."
        },
        {
          "q": "Когда проходит Viernes Culturales?",
          "a": "В последнюю пятницу каждого месяца, вечером, вдоль Калье-Очо — с живой музыкой, искусством и уличной едой."
        }
      ]
    },
    "brickell": {
      "title": "Брикелл и Даунтаун",
      "intro": "Небоскрёбы, Bayside и залив — чем заняться в Брикелле и центре Майами."
    },
    "seeAlso": "См. также:",
    "faqTitle": "Частые вопросы"
  },
  "partners": {
    "title": "Хотите больше лодок на выбор?",
    "text": "Sailo — площадка аренды лодок, на которой сотни частных лодок и яхт в Майами: от небольших катеров до больших яхт с экипажем. Цены, свободные даты и бронирование — на её сайте.",
    "button": "Смотреть лодки"
  },
  "empty": {
    "title": "Скоро",
    "text": "Мы подключаем первых партнёров для этого списка. А пока — несколько идей для начала."
  },
  "card": {
    "tour": "Экскурсии и впечатления",
    "boat": "Яхты и круизы",
    "from": "от {{price}}",
    "reviews_one": "{{count}} отзыв",
    "reviews_few": "{{count}} отзыва",
    "reviews_many": "{{count}} отзывов",
    "reviews_other": "{{count}} отзыва"
  },
  "footer": {
    "sisterSites": "Наши другие гиды:",
    "about": "Экскурсии, морские прогулки, аэроглиссеры в Эверглейдс и чем заняться в Майами.",
    "thingsToDo": "Чем заняться",
    "areas": "Районы",
    "language": "Язык",
    "disclosure": "© miami-todo.com · Независимый путеводитель. Некоторые ссылки партнёрские: если вы бронируете у наших партнёров, мы можем получить комиссию — для вас цена не меняется.",
    "tours": "Экскурсии и туры"
  },
  "notFound": {
    "title": "Страница не найдена",
    "text": "Страница, которую вы ищете, не существует или была перемещена.",
    "home": "На главную Miami To-Do"
  },
  "sample": {
    "dinner": {
      "category": "Вечер вдвоём",
      "title": "Ужин с видом",
      "text": "Вечера у воды с незабываемым видом на Майами.",
      "place": "Брикелл",
      "alt": "Терраса ресторана с видом на небоскрёбы Майами на закате"
    },
    "beach": {
      "category": "Пляжный день",
      "title": "Пляжи Майами-Бич",
      "text": "Солнце, океан и спасательные вышки Саут-Бич.",
      "place": "Майами-Бич",
      "alt": "Спасательная вышка на пляже Майами-Бич, за ней отели"
    },
    "yacht": {
      "category": "Яхты и круизы",
      "title": "Частная яхта",
      "text": "Прогулка вдоль побережья Майами с полным комфортом.",
      "place": "Залив Бискейн",
      "alt": "Яхта на фоне небоскрёбов Майами"
    }
  },
  "stub": {
    "saved": {
      "title": "Избранное",
      "intro": "Сохраняйте понравившиеся впечатления в одном месте.",
      "text": "Избранное скоро появится. А пока — несколько идей для начала."
    },
    "account": {
      "title": "Аккаунт",
      "intro": "Ваш аккаунт Miami To-Do.",
      "text": "Аккаунты скоро появятся. А пока — несколько идей для начала."
    }
  },
  "tours": {
    "searchLabel": "Поиск экскурсий",
    "searchPlaceholder": "Аэролодка, круиз на закате, Ки-Уэст…",
    "resultsFor": "Результаты по запросу «{{query}}»",
    "noResults": "По запросу «{{query}}» ничего не найдено.",
    "clearSearch": "Сбросить поиск",
    "showMore_one": "Показать ещё {{count}}",
    "showMore_few": "Показать ещё {{count}}",
    "showMore_many": "Показать ещё {{count}}",
    "showMore_other": "Показать ещё {{count}}"
  },
  "detail": {
    "book": "Забронировать",
    "via": "через {{partner}}",
    "delisted": "Это предложение больше недоступно.",
    "duration": "Длительность",
    "rating": "Рейтинг",
    "price": "Цена",
    "more": "Другие впечатления"
  },
  "tourFacts": {
    "includedTitle": "Что входит в стоимость",
    "included": "Включено",
    "excluded": "Не включено",
    "meetingTitle": "Встреча и трансфер",
    "knowBeforeTitle": "Важно знать",
    "private": "Индивидуальная экскурсия — только ваша группа",
    "shared_one": "Групповая экскурсия, до {{count}} участника",
    "shared_few": "Групповая экскурсия, до {{count}} участников",
    "shared_many": "Групповая экскурсия, до {{count}} участников",
    "shared_other": "Групповая экскурсия, до {{count}} участника",
    "languages": "Языки гида: {{languages}}",
    "pickupOptions": {
      "PICKUP_EVERYONE": "Трансфер от отеля для всех участников",
      "PICKUP_AND_MEET_AT_START_POINT": "Трансфер от отеля или встреча на месте старта",
      "MEET_EVERYONE_AT_START_POINT": "Встреча на месте старта (без трансфера)"
    }
  }
}
